type Range = [number, number];

function getMatchRanges(text: string, words: string[]): Range[] {
  const lowerText = text.toLowerCase();
  const ranges: Range[] = [];
  for (const word of words) {
    const lowerWord = word.toLowerCase();
    let pos = 0;
    while (pos < text.length) {
      const found = lowerText.indexOf(lowerWord, pos);
      if (found === -1) break;
      ranges.push([found, found + lowerWord.length]);
      pos = found + lowerWord.length;
    }
  }
  return ranges;
}

function mergeRanges(ranges: Range[]): Range[] {
  const sorted = [...ranges].sort((a, b) => a[0] - b[0]);
  return sorted.reduce<Range[]>((merged, [start, end]) => {
    const last = merged[merged.length - 1];
    if (last && start <= last[1]) {
      last[1] = Math.max(last[1], end);
    } else {
      merged.push([start, end]);
    }
    return merged;
  }, []);
}

export function HighlightMatch({
  text,
  query,
}: Readonly<{ text: string; query: string }>) {
  const words = query.split(/\s+/).filter(Boolean);
  const ranges = mergeRanges(getMatchRanges(text, words));

  if (ranges.length === 0) return <>{text}</>;

  const parts: React.ReactNode[] = [];
  let cursor = 0;
  for (const [start, end] of ranges) {
    if (start > cursor) parts.push(text.slice(cursor, start));
    parts.push(
      <span key={start} data-testid="highlight-match" className="font-bold">
        {text.slice(start, end)}
      </span>
    );
    cursor = end;
  }
  if (cursor < text.length) parts.push(text.slice(cursor));

  return <>{parts}</>;
}
